import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from "../../AuthContext";
import { TableRecapData } from "../RecapUserData/TableRecapData";
import { TableRowAddress } from "../RecapUserData/TableRowAddress";
import { TableRowService } from "../RecapUserData/TableRowService";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { GdacsTimeline } from "../Layout/GdacsTimeline";
import { useViewPort } from "../Hooks/useViewPort";

const UserRecapData = (props) => {
    const authContext = useContext(AuthContext);
    const params = props.params;
    const [checkedItems, setCheckedItems] = React.useState();
    const now = 60;
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const { width } = useViewPort();
    const breakpoint = 620;

    const handleChange = (e) => {
        setCheckedItems({
            ...checkedItems,
            [e.target.name]: e.target.checked
        });
        if (props.handleCheck)
            props.handleCheck(e.target.checked);
    };


    return (
        <div>
            <form>
                <h4 className="d-flex justify-content-center hr-title">Confirm Data Account</h4>
                <br />
                {width > breakpoint &&
                    <GdacsTimeline navIndex={navIndex} user={params.idUser} />
                }
                {width < breakpoint &&
                    <>
                        {props.params.idUser === 0 &&
                            <ProgressBar>
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} label={5} />
                            </ProgressBar>
                        }
                        {props.params.idUser !== 0 &&
                            <ProgressBar>
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25} label={4} />
                            </ProgressBar>
                        }
                    </>
                }
                <br />
                <br />
                <div>
                    <TableRecapData params={props.params} />
                    <TableRowAddress params={props.params} />
                    <TableRowService params={props.params} />
                    <br />
                    <div className="p_summary" style={{ fontSize: "12px" }}> <b>Conditions for use:</b><br />
                    I understand that the notifications provided by GDACS are calculated by a computer without human intervention and that errors are possible.
                    I understand that I cannot use this information for decision making without alternate sources of information to confirm or disprove the GDACS events.
                    The service can only be used for disaster monitoring purposes. JRC can terminate accounts unilateraly without notice in case of abuse.
                    The data you provide in this form is kept for the purpose of alerting you and for internal usage statistics.
                    The information will not be disclosed to third parties, unless it is necessary for the fulfillment of the purpose identified above.
                    Your data is kept for 1 year after you unregister from the system. For further information, see the European Commission Personal Data
                    Protection, see <a href="http://ec.europa.eu/dpo-register/detail/DPR-EC-00240" target="_blank">DPR-EC-00240.1</a>. For further inquiries
                    contact  <a href="/About/contactus.aspx" target="_blank">us</a>
                    </div>
                    <br />
                    <div className="col-12 row" style={{ flexWrap: "nowrap" }}>
                        <input type='checkbox' aria-label="Checkbox for following text input" onClick={handleChange} style={{ maxWidth: "20px", marginLeft: "10px", marginTop: "5px" }} /> &nbsp;
                        <label style={{ fontSize: "14px", maxWidth: "-moz-fit-content" }}>    Accept Conditions for use</label>
                    </div>
                </div>
            </form>
        </div>
    )
}
export { UserRecapData }